import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { firestore, auth } from './firebase';
import { doc, getDoc } from 'firebase/firestore';

const DashboardRedirect = () => {
  const history = useNavigate();

  useEffect(() => {
    const fetchUserRole = async () => {
      const user = auth.currentUser;
      if (user) {
        console.log("User: ", user.uid);
        const userRef = doc(firestore, 'users', user.uid);
        console.log("User Reference: ", userRef);
        const docSnap = await getDoc(userRef);
        console.log("Document Snapshot: ", docSnap);
        if (docSnap.exists()) {
          const data = docSnap.data();
          console.log("Document Data: ", data);
          const { role } = data;
          if (role === 'worker') {
            history('/worker-dashboard');
          } else {
            history('/customer-dashboard');
          }
        } else {
          console.log("No such document!");
        }
      } else {
        console.log("No authenticated user found.");
      }
    };
    fetchUserRole();
  }, [auth, firestore, history]);

  return <div className="fade-in">Lädt...</div>;
};

export default DashboardRedirect;
